import httpUtils from '../../utils/HttpUtils'

class StoreShopService {

  //获取卖场店铺列表信息
  async shopList(storeId = '',sort = '',categoryId = '',pageNo = 1) {
    let result = null;
    try {
      let sortOrder = 'desc';
      result = await httpUtils.post('/mall/store/shop/list', {storeId,sort,categoryId,sortOrder,pageNo})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //获取卖场店铺门店列表信息
  async addressList(storeId = '',shopId = '') {
    let result = null;
    try {
      result = await httpUtils.post('/mall/store/shop/address/list', {storeId,shopId})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

}
export default new StoreShopService()
